/**
 * Created by tong on 2018/1/30.
 */
import React from 'react';

class customer extends React.Component {
  render() {
    return <div>
      {this.props.children}
    </div>
  }
}
export default customer;


// WEBPACK FOOTER //
// ./src/routes/customer/index.js